export const formatTime = (time: string) =>

  // console.log('time&&&&&& :', time)
  time?.slice(0, 2) + ":" + time?.slice(2);



export const convertTimeToHoursAndMinutes = (time: string) => {
  // console.log('time******* :', time);
  let formattedTime = time.toString().padStart(4, "0");

  let hours = parseInt(formattedTime.slice(0, 2), 10);
  let minutes = parseInt(formattedTime.slice(2), 10);

  if (minutes >= 60) {
    hours += Math.floor(minutes / 60);
    minutes = minutes % 60;
  }

  let hoursText = hours > 0 ? `${hours} hr${hours > 1 ? "s" : ""}` : "";
  let minutesText = minutes > 0 ? `${minutes} minute${minutes > 1 ? "s" : ""}` : "";

  return [hoursText, minutesText].filter(Boolean).join(" ");
};
